import { render, staticRenderFns } from "./giftCurrency.vue?vue&type=template&id=76183289&scoped=true"
import script from "./giftCurrency.vue?vue&type=script&lang=js"
export * from "./giftCurrency.vue?vue&type=script&lang=js"
import style0 from "./giftCurrency.vue?vue&type=style&index=0&id=76183289&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76183289",
  null
  
)

export default component.exports